import React from "react";
import Icon from "../../../components/AppIcon";
import PageHeader from "../../../components/PageHeader";
import { PAGE_CONTENT_CLASS } from "../../../components/layout/PageContent";
import ModelLibraryCardShell from "../../../pages/model-library/components/ModelLibraryCardShell";
import { cn } from "../../../utils/cn";
import FakeAppChrome from "../FakeAppChrome";
import { TOUR_LIBRARY_MODELS } from "../tourData";

const ModelLibraryScene = () => (
  <FakeAppChrome activeNavId="library">
    <div className={cn(PAGE_CONTENT_CLASS, "!pt-6")}>
      <PageHeader
        title="Biblioteca de Modelos"
        subtitle="Modelos do sistema, personalizados e favoritos para gerar documentos"
        icon="Library"
        className="mb-4 md:mb-6"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 lg:gap-5 items-stretch max-w-6xl">
        <ModelLibraryCardShell accent>
          <div className="flex items-center gap-2.5 mb-3">
            <div className="flex items-center justify-center w-9 h-9 rounded-lg bg-primary/10 shrink-0">
              <Icon name="FileText" size={18} className="text-primary" />
            </div>
            <div className="min-w-0">
              <h2 className="text-base font-semibold text-foreground tracking-tight truncate">
                Modelos do Sistema
              </h2>
              <p className="text-xs text-muted-foreground truncate">
                Modelos prontos por categoria
              </p>
            </div>
          </div>

          <p className="text-xs font-medium text-muted-foreground mb-2">
            Categoria: Corretores
          </p>

          <div className="flex-1 min-h-0 space-y-1.5">
            {TOUR_LIBRARY_MODELS.map((model) => (
              <div
                key={model.id}
                className={cn(
                  "w-full flex items-center justify-between gap-2 px-3 py-2.5 rounded-lg border text-sm",
                  model.highlight
                    ? "border-primary bg-primary/12 text-primary font-medium ring-2 ring-primary/30"
                    : "border-transparent bg-muted/30 text-foreground"
                )}
              >
                <span className="truncate">{model.name}</span>
                <Icon
                  name={model.highlight ? "Check" : "ChevronRight"}
                  size={16}
                  className="shrink-0"
                />
              </div>
            ))}
          </div>
        </ModelLibraryCardShell>

        <ModelLibraryCardShell className="opacity-70">
          <div className="flex items-center gap-2.5 mb-3">
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-muted shrink-0">
              <Icon name="FolderOpen" size={18} className="text-muted-foreground" />
            </div>
            <div>
              <h2 className="text-base font-semibold">Modelos Personalizados</h2>
              <p className="text-xs text-muted-foreground">Seus modelos salvos</p>
            </div>
          </div>
          <p className="text-xs text-muted-foreground py-8 text-center">
            Disponíveis após criar sua conta
          </p>
        </ModelLibraryCardShell>

        <ModelLibraryCardShell className="opacity-70 hidden xl:flex">
          <div className="flex items-center gap-2.5 mb-3">
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-muted shrink-0">
              <Icon name="Star" size={18} className="text-muted-foreground" />
            </div>
            <div>
              <h2 className="text-base font-semibold">Favoritos</h2>
              <p className="text-xs text-muted-foreground">Acesso rápido</p>
            </div>
          </div>
          <p className="text-xs text-muted-foreground py-8 text-center">
            Disponíveis após criar sua conta
          </p>
        </ModelLibraryCardShell>
      </div>
    </div>
  </FakeAppChrome>
);

export default ModelLibraryScene;
